import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { useAdminUserStats } from './hooks/useAdmin';
import { useAuthStore } from '@/app/auth/stores/auth.store';
import { Button } from '@/shared/components/Button';
import { LiveStatTile } from '@/shared/components/dashboard/LiveStatTile';

interface UsersLiveTileProps {
  animateIndex?: number | undefined;
  className?: string;
}

export const UsersLiveTile = ({ animateIndex, className }: UsersLiveTileProps) => {
  const { t } = useTranslation('userManagement');
  const canView = useAuthStore((state) => state.isManagerOrAdmin());
  const userStatsQuery = useAdminUserStats();
  const stats = userStatsQuery.data;

  if (!canView) {
    return null;
  }

  return (
    <LiveStatTile
      value={stats?.active ?? 0}
      total={stats?.total ?? 0}
      label={t('live.active')}
      icon={Users}
      isLoading={userStatsQuery.isLoading}
      animateIndex={animateIndex}
      className={className}
      actions={
        <Button
          variant="soft"
          color="sky"
          fullWidth
          leadingIcon={<Users size={16} />}
          to="/admin/users"
        >
          {t('live.viewUsers')}
        </Button>
      }
    />
  );
};
